module.exports = __webpack_public_path__ + "static/Fuar_GORSEL-ae1f07e4130ed2ccb6eecb034178ef47.jpg";